// extracted by mini-css-extract-plugin
module.exports = {"button":"index-module__button___Ox42E"};